<template lang="pug">
  el-scrollbar.h-100
    IndexHeader
    div.ma-auto.listbg
      div.w12.ma-auto
        div.line_height
        div.list_top_title 您所在的位置：首页 > {{getDesc(queryType)}}
        div.line_height
        div.list_bg_white
          div.line_height
          div.guide_title {{getDesc(queryType)}}
          div(v-if="queryType=='queType1'")
              div.guide_sub_text 一、账号登陆手机号更改
              div.guide_text 告知业务对应的建华子公司采购员，由采购员申请更改账号。
          div(v-if="queryType=='queType2'")
              div.guide_sub_text 一、供应商账号注册
              div.guide_text 操作路径：登录www.jhsrm.com，点击界面右上角【免费注册】。
              div.guide_img
                el-image(:src="require('@/assets/image/register1.png')")
              div.guide_text 填写信息：注册手机号-公司名称-注册人姓名-账号密码-勾选注册协议-点击注册。
              div.guide_img
                el-image(:src="require('@/assets/image/register2.png')")
          div(v-if="queryType=='queType3'")
              div.guide_sub_text 一、供应商认证
              div.guide_text 操作路径：使用注册账号登录http://www.jianhuabm.com:7006/login，点击界面右上角【认证】按照提示进行供应商认证。
              div.guide_text 企业认证：用户是企业性质供应商，请选择上方左侧企业认证方式。
              div.guide_text 1、管理组织：想要与之合作的建华分公司，填写时先确定好管理组织。
              div.guide_text 2、企业工商信息如实填写，否则无法审核通过 。
              div.guide_text 3、信息填写完毕勾选同意建华建材认证协议后点击提交。
              div.guide_text 4、系统管理员审核注册信息。
              div.guide_img
                el-image(:src="require('@/assets/image/register3.png')")
              div.guide_img
                el-image(:src="require('@/assets/image/register4.png')")
              div.guide_img
                el-image(:src="require('@/assets/image/register5.png')")
              div.guide_text 个人认证：用户是个人性质供应商，请选择个人认证方式，个体名称为个人姓名+身份证后四位；如果是有登记店铺名称个体工商户从“企业认证”填写资料
              div.guide_text 进行认证。
              div.guide_text 1、管理组织：想要与之合作的建华分公司，填写时先确定好管理组织。
              div.guide_text 2、其他信息如实填写，否则无法审核通过。
              div.guide_text 3、信息填写完毕勾选同意建华建材认证协议后点击提交。
              div.guide_text 4、系统管理员审核注册信息。
              div.guide_img
                el-image(:src="require('@/assets/image/register6.png')")
              div.guide_img
                el-image(:src="require('@/assets/image/register7.png')")
              div.guide_text 在此页面选择感兴趣的物料分类，将默认为关注此物料分类的商机，用户也可以暂不设置。此页面设置完成后用户进入待审核状态，等待管理组织审核。
          div.line_height
          div.line_height
          div.guide_button_width
            el-button.guide_button(v-if="!user" type="primary" @click="goto('/register')") 立即注册
            el-button.guide_button(v-if="user && user.type==1 && user.checkstatus==1" type="primary" @click="goto('/authentication')") 立即注册
            el-button.guide_button(v-if="user && user.type==1 && user.checkstatus==5" type="primary" @click="goto('/authentication')") 立即注册
            el-button.guide_button(v-if="user && !(user.type==1 && user.checkstatus!=3)" size="mini" @click="goto(menu[0].children?menu[0].children[0].name:menu[0].name)" type="primary") 立即注册
          div.line_height
          div.line_height
        div.line_height
    IndexFooter
</template>
<script>
export default {
  components: {},
  filters: {},
  data() {
    return {
        queryType:""
    };
  },
  methods: {
    getDesc(type){
        return type =='queType1'?'账号登陆手机号更改':type =='queType2'?"供应商账号注册":"供应商认证";
    }
  },
  async mounted() {
    if (this.$route.hash) {
      document.getElementById(this.$route.hash.split("#")[1]).scrollIntoView();
    }
  },
  created() {
      this.queryType = this.$route.params.queType;
  }
};
</script>
<style scoped></style>
